import { ChartType } from 'shared/types/analytics';
import type { ChartViewModel } from '../catalog/types';

export const EMPTY_CHART_VIEW_MODEL: ChartViewModel = {
  type: ChartType.donut,
  isEmpty: true,
};
